import { SupplierBusyPeriod } from "pages/out-of-office/out-of-office.typing";
import { useState } from "react";

export const useBusyPeriodListItem = (period: SupplierBusyPeriod, onDelete: (id: string) => void) => {
  const [confirmingDelete, setConfirmingDelete] = useState(false);
  const hasComment = Boolean(period.comments?.trim());

  const startConfirmDelete = () => setConfirmingDelete(true);
  const cancelConfirmDelete = () => setConfirmingDelete(false);
  const confirmDelete = () => onDelete(period.id);

  return {
    confirmingDelete,
    hasComment,
    startConfirmDelete,
    cancelConfirmDelete,
    confirmDelete,
  };
};
